import { render, staticRenderFns } from "./SpecialRequest.vue?vue&type=template&id=fac3976e&scoped=true"
import script from "./SpecialRequest.vue?vue&type=script&lang=js"
export * from "./SpecialRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac3976e",
  null
  
)

export default component.exports